import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
@Component({
  selector: 'app-agent-monthly-report',
  templateUrl: './agent-monthly-report.component.html',
  styleUrls: ['./agent-monthly-report.component.scss']
})
export class AgentMonthlyReportComponent implements OnInit {

  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  month_list_for_last_12_months: any = [];
  selected_month: any;
  milk_product_list: any;
  fermented_product_list: any;
  session_list: any;
  milk_product_report: any;
  fermented_product_report: any;
  milk_product_date_list: any;
  fermented_product_date_list: any;
  milk_product_total_price: any;
  fermented_product_total_price: any;
  overall_month_report: any;
  overall_month_total_price: any;
  product_list: any;
  global_config_dict: any;
  commission_details: any;
  is_data_available = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;

  constructor(private http: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;

    // need to move
    let today = new Date();
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
  }

  getMonthlyReport(business_code) {
    console.log('-------------------------------------------------')
    console.log(business_code);
    console.log(Object.values(this.selected_month));
    console.log('-------------------------------------------------')
    const data_dict = {
      'from': 'portal',
      'business_code': business_code,
      'selected_month': this.selected_month
    };
    console.log(data_dict)
    this.is_data_available = false;
    this.http.serveAgentMonthlyReport(data_dict).subscribe((data) => {
      console.log(data);
      this.is_data_available = true;
      if (data['status']) {
        this.milk_product_list = data['milk_product_list'];
        this.fermented_product_list = data['fermented_product_list'];
        this.session_list = data['session_list'];
        this.milk_product_report = data['milk_product_report']['product_details'];
        this.milk_product_total_price = data['milk_product_report']['total_price'];
        this.milk_product_date_list = Object.keys(this.milk_product_report).sort();
        this.fermented_product_report = data['fermented_product_report']['product_details'];
        this.fermented_product_total_price = data['fermented_product_report']['total_price'];
        this.overall_month_report = data['overall_month_report']['product_details'];
        this.overall_month_total_price = data['overall_month_report']['total_price'];
        this.product_list = data['product_list'];
        this.global_config_dict = data['global_config_dict'];
        this.commission_details = data['commission_details'];
        this.fermented_product_date_list = Object.keys(this.fermented_product_report).sort();
      } else {
        alert(business_code + 'code is not available.');
        this.milk_product_list = null;
      }
    }, (error) => {
      this.is_data_available = true
      console.log(error);
    });
  }

  // converToPdf() {
  //   var data = document.getElementById('contentToConvert');
  //   html2canvas(data).then(canvas => {
  //     // Few necessary setting options
  //     let imgWidth = 208;
  //     let pageHeight = 295;
  //     let imgHeight = canvas.height * imgWidth / canvas.width;
  //     let heightLeft = imgHeight;

  //     const contentDataURL = canvas.toDataURL('image/png')
  //     let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
  //     let position = 0;
  //     pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
  //     pdf.save();
  //   });
  //   // const doc = new jspdf();
  //   // doc.autoTable({ html: '#contentToConvert' });
  //   // doc.save('table.pdf');
  // }

  ngOnInit() {
    console.log('data');
  }

}
